import { Field, reduxForm, reset } from 'redux-form';
import Dialog from 'material-ui/Dialog';
import { CancelButton, SubmitButtonModal } from '../../../../components/buttons';
// import RaisedButton from 'material-ui/RaisedButton';
import {
  renderAutoCompleteSingleSelectAsync,
  renderDateField,
} from '../../../../components/reduxFields';
import React, { Component } from 'react';
import { getMasterData, getMasterDiagnosisByName } from './actions/soapActions';
import { connect } from 'react-redux';
import moment from 'moment';
import { Scrollbars } from 'react-custom-scrollbars';
const validate = (values) => {
  const errors = {};

  if (!values.ICDID || !Number.isInteger(values.ICDID)) {
    errors.ICDID = 'Please select diagnosis code';
  }
  if (!values.DiagnosisDate) {
    errors.DiagnosisDate = 'Please select diagnosis date';
  }
  return errors;
};

// props.master_data.masterICD

class ProblemModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: true,
      masterICD: [],
      PatientID: props.patientid,
      DiagnosisDate: props.diagnoseObj ? props.diagnoseObj.attributes.DiagnosisDate : null,
      diagnosis_id: props.diagnoseObj ? props.diagnoseObj.id : null,
    };
    this.filter = {
      searchText: '',
    };

    this.onDateChange = this.onDateChange.bind(this);
    this.handleSearchDiagnosis = this.handleSearchDiagnosis.bind(this);
  }

  handleOpen = () => {
    this.setState({ open: true });
  };

  handleClose = () => {
    this.setState({ open: false });
    this.props.closeDialog();
  };

  loadDiagnosis() { // , code: this.filter.searchText
    let searchObj = {
      page_number: 1,
      page_size: 5,
      contain_filters: this.filter.searchText ? { description: this.filter.searchText } : null,
    };
    this.props.getMasterDiagnosisByName(searchObj);
  }

  componentWillMount() {
    this.loadDiagnosis();
  }

  onDateChange(input, value) {
    input.onChange(moment(value).format('YYYY-MM-DD'));
    this.setState({ [input.name]: value });
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.searched_ICDs && nextProps.searched_ICDs.length && this.props.searched_ICDs !== nextProps.searched_ICDs) {
      let ICDdata = [];
      nextProps.searched_ICDs.forEach((icd, index) => {
        if (!this.props.diagnosisArray.find((i) => i.ICDCode === icd.attributes.Code)) {
          ICDdata.push({
            'id': parseInt(icd.id, 10),
            'value': icd.attributes.value,
          });
        }
      });
      if (ICDdata.length) {
        this.setState({ masterICD: ICDdata });
      }
    }

    let self = this;
    document.onkeydown = function(evt) {
      evt = evt || window.event;
      if (evt.keyCode === 27) {
        self.handleClose();
      }
    };
  }

  handleNewRequest = (input, selectedRecord) => {
    input.onChange(selectedRecord.value);
  }
  handleSearchDiagnosis(value, dataSource) {
    // console.log(value, dataSource);
    if (value.trim().length >= 3) {
      this.filter.searchText = value;
      this.loadDiagnosis();
    } else if (value === '') {
      this.filter.searchText = '';
      this.loadDiagnosis();
    }
  }

  // submit handlers for the soap notes ....
  onAddSubmitubmitHandler = (formProps) => {
    this.props.handleAddDiagnosis(formProps);
    this.handleClose();
  }
  onAddMoreSubmitubmitHandler = (formProps) => {
    this.props.handleAddDiagnosis(formProps);
    this.props.dispatch(reset('Soap_ProblemModal'));
    this.setState({ DiagnosisDate: null });
    this.filter.searchText = '';
    this.loadDiagnosis();
  }

  render() {
    const { handleSubmit } = this.props;
    let submitButton = null;
    let addMoreButton = null;
    submitButton = <SubmitButtonModal className="mr-15" label="Add" onSubmit={handleSubmit(this.onAddSubmitubmitHandler)}/>;
    addMoreButton = <SubmitButtonModal label="Add More" onSubmit={handleSubmit(this.onAddMoreSubmitubmitHandler)}/>;
    let btns = [
      <CancelButton className="mr-15" onTouchTap={this.handleClose}/>,
      submitButton, addMoreButton,
    ];
    const actions = [ <div className="sm-btn-scroll"><Scrollbars>{btns} </Scrollbars></div>]
    return (
      <div>
        {this.state.open ?
          <Dialog className="custom_modal"
            title={this.props.diagnoseObj ? 'Edit Diagnosis' : 'Add Diagnosis'}
            modal={false}
            open={this.state.open}
            actions={actions}
            autoScrollBodyContent={true}
          >
            <div className="row">
              <div className="col-sm-12">
                <form className="readmin-form custom_form">
                  <div className="row">
                    <div className="col-sm-12 col-md-8 require mt-35">
                      <Field
                        name="ICDID"
                        label="Search Diagnosis"
                        options={this.state.masterICD}
                        handleNewRequest={this.handleNewRequest}
                        handleUpdateInput={this.handleSearchDiagnosis}
                        component={renderAutoCompleteSingleSelectAsync}
                        openOnFocus={true}
                      />
                    </div>
                    <div className="col-sm-12 col-md-4 require">
                      <Field
                        name="DiagnosisDate"
                        placeholder="Date of diagnosis"
                        component={renderDateField}
                        openToYearSelection = {true}
                        maxDate={new Date()}
                        locale="en-US"
                        selected={this.state.DiagnosisDate}
                        onDateChange={this.onDateChange}
                      />
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </Dialog> : null}
      </div>
    );
  }
}


function mapStateToProps(state, ownProps) {
  return {
    loading: state.soap.loading,
    searched_ICDs: state.soap.searched_ICDs && state.soap.searched_ICDs.data ? state.soap.searched_ICDs.data : [],
  };
}
ProblemModal = reduxForm({
  form: 'Soap_ProblemModal',
  validate,
  enableReinitialize: true,
})(ProblemModal);
export default connect(mapStateToProps, { getMasterData, getMasterDiagnosisByName })(ProblemModal);



// WEBPACK FOOTER //
// ./src/modules/scheduling/components/SessionNotes_Psychological_SWAN/soap_daignosisModal.js